
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class SplittingItemsDialog extends Serenity.EntityDialog<SplittingItemsRow, any> {
        protected getFormKey() { return SplittingItemsForm.formKey; }
        //protected getIdProperty() { return SplittingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return SplittingItemsRow.localTextPrefix; }
        //protected getNameProperty() { return SplittingItemsRow.nameProperty; }
        //protected getService() { return SplittingItemsService.baseUrl; }
        protected getDeletePermission() { return SplittingItemsRow.deletePermission; }
        protected getInsertPermission() { return SplittingItemsRow.insertPermission; }
        protected getUpdatePermission() { return SplittingItemsRow.updatePermission; }

        protected form = new SplittingItemsForm(this.idPrefix);

    }
}